import { createContext } from "react";

export type LayoutContextData = {
  isExpandedMode: boolean;
  isDocumentationBarVisible: boolean;
};

export const LayoutContext = createContext<LayoutContextData | undefined>(undefined);
LayoutContext.displayName = "LayoutContext";
